import { useTranslation } from "react-i18next";
import { useOnline } from "@/lib/useOnline";
import { Icon } from "@/components/Icon";

/**
 * Global non-blocking connectivity banner (issue #77).
 *
 * Fixed to the top so it never collides with the bottom toast chrome
 * (schedule toasts, the PWA update prompt). Renders nothing while
 * online; disappears reactively when connectivity returns.
 */
export function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnline();

  if (online) return null;

  return (
    <div
      role="status"
      data-testid="offline-banner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 80,
        background: "var(--clay-900)",
        color: "#fff",
        padding: "10px 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        boxShadow: "var(--shadow-md)",
        font: "var(--fw-medium) var(--fs-sm)/1.3 var(--font-body)",
        textAlign: "center",
      }}
    >
      <Icon name="globe" size={16} color="var(--honey-500)" />
      {t("offline.banner")}
    </div>
  );
}
